module.exports = __webpack_public_path__ + "img/ic-dropdown-pea.6f91d33e.svg";